
export class Rectangle {
	public X: number;
	public Y: number;
	public Width: number;
	public Height: number;
}

export class Point {

	constructor(
		public X: number = 0,
		public Y: number = 0) {
	}

	public Equals(other: Point): boolean {
		if (!other)
			return false;

		if (this == other)
			return true;

		return other.X == this.X && other.Y == this.Y;
	}
}

export class CGAffineTransform {
            public xx: number;   // a
            public yx: number;   // b 
            public xy: number;   // c
            public yy: number;   // d
            public x0: number;   // tx
            public y0: number;   // ty

	//
	// Constructors
	//
	constructor(xx: number, yx: number, xy: number, yy: number, x0: number, y0: number)
	{
		this.xx = xx;
		this.yx = yx;
		this.xy = xy;
		this.yy = yy;
		this.x0 = x0;
		this.y0 = y0;
	}
		
	// Identity
	public static MakeIdentity(): CGAffineTransform {
		return new CGAffineTransform(1, 0, 0, 1, 0, 0);
	}
		
	public static MakeRotation(angle:number): CGAffineTransform {
		return new CGAffineTransform(
			Math.cos(angle),Math.sin(angle),
			- Math.sin(angle),Math.cos(angle),
			0, 0);
	}

	public static MakeScale(sx:number, sy:number): CGAffineTransform {
		return new CGAffineTransform(sx, 0, 0, sy, 0, 0);
	}

	public static MakeTranslation(tx:number, ty:number): CGAffineTransform {
		return new CGAffineTransform(1, 0, 0, 1, tx, ty);
	}

	//public static Multiply(a: CGAffineTransform, b: CGAffineTransform ): CGAffineTransform {
	//	return new CGAffineTransform(a.xx * b.xx + a.yx * b.xy,
	//		a.xx * b.yx + a.yx * b.yy,
	//		a.xy * b.xx + a.yy * b.xy,
	//		a.xy * b.yx + a.yy * b.yy,
	//		a.x0 * b.xx + a.y0 * b.xy + b.x0,
	//		a.x0 * b.yx + a.y0 * b.yy + b.y0);
	//}

	public Multiply(b:CGAffineTransform):void{
		var a = this;
		this.xx = a.xx * b.xx + a.yx * b.xy;
		this.yx = a.xx * b.yx + a.yx * b.yy;
		this.xy = a.xy * b.xx + a.yy * b.xy;
		this.yy = a.xy * b.yx + a.yy * b.yy;
		this.x0 = a.x0 * b.xx + a.y0 * b.xy + b.x0;
		this.y0 = a.x0 * b.yx + a.y0 * b.yy + b.y0;
	}
		
	//public void Scale(float sx, float sy)
	//{
	//	Multiply(MakeScale(sx, sy));
	//}

	//public void Translate(float tx, float ty)
	//{
	//	Multiply(MakeTranslation(tx, ty));
	//}

	//public void Rotate(float angle)
	//{
	//	Multiply(MakeRotation(angle));
	//}
		
	//public bool IsIdentity {
	//	get {
	//		return xx == 1 && yx == 0 && xy == 0 && yy == 1 && x0 == 0 && y0 == 0;
	//	}
	//}
		
    //        public override String ToString ()
	//{
	//	String s = String.Format("xx:{0:##0.0#} yx:{1:##0.0#} xy:{2:##0.0#} yy:{3:##0.0#} x0:{4:##0.0#} y0:{5:##0.0#}", xx, yx, xy, yy, x0, y0);
	//	return s;
	//}
                
    //        public static bool operator == (CGAffineTransform lhs, CGAffineTransform rhs)
	//{
	//	return (lhs.xx == rhs.xx && lhs.xy == rhs.xy &&
	//		lhs.yx == rhs.yx && lhs.yy == rhs.yy &&
	//		lhs.x0 == rhs.x0 && lhs.y0 == rhs.y0);
	//}
                
    //        public static bool operator != (CGAffineTransform lhs, CGAffineTransform rhs)
	//{
	//	return !(lhs == rhs);
	//}

	//public static CGAffineTransform operator * (CGAffineTransform a, CGAffineTransform b)
	//{
	//	return new CGAffineTransform(a.xx * b.xx + a.yx * b.xy,
	//		a.xx * b.yx + a.yx * b.yy,
	//		a.xy * b.xx + a.yy * b.xy,
	//		a.xy * b.yx + a.yy * b.yy,
	//		a.x0 * b.xx + a.y0 * b.xy + b.x0,
	//		a.x0 * b.yx + a.y0 * b.yy + b.y0);
	//}
                
    //        public override bool Equals(object o)
	//{
	//	if (!(o is CGAffineTransform))
	//	return false;
    //                else
	//	return (this == (CGAffineTransform) o);
	//}
                
    public GetHashCode():number {
		return this.xx ^ this.xy ^
		this.yx ^ this.yy ^
		this.x0 ^ this.y0;
	}
                
	//public PointF TransformPoint (PointF point)
	//{
	//	return new PointF(xx * point.X + xy * point.Y + x0,
	//		yx * point.X + yy * point.Y + y0);
	//}

	//[DllImport(Constants.CoreGraphicsLibrary)]
	//public extern static RectangleF CGRectApplyAffineTransform (RectangleF rect, CGAffineTransform t);

	//public RectangleF TransformRect (RectangleF rect)
	//{
	//	return CGRectApplyAffineTransform(rect, this);
	//}

	//[DllImport(Constants.CoreGraphicsLibrary)]
	//public extern static CGAffineTransform CGAffineTransformInvert (CGAffineTransform t);

	//public Invert(): CGAffineTransform {
			
	//}

}

export enum MatrixOrder { Prepend, Append }

export class Matrix {
	private transform: CGAffineTransform;
		
	constructor()
	{
		this.transform = CGAffineTransform.MakeIdentity();
	}

		
	// properties
	public get Elements(): number[] {
		return [ this.transform.xx, this.transform.yx, this.transform.xy, this.transform.yy, this.transform.x0, this.transform.y0 ];
	}
		
	public Equals (obj:any):boolean
	{
		if (!(obj instanceof Matrix))
			return;

		var m = <Matrix>obj;

		if (m != null) {
			var o = m.transform;
			var t = this.transform;
			return (o.x0 == t.x0 && o.y0 == t.y0 &&
				o.xx == t.xx && o.yy == t.yy &&
				o.xy == t.xy && o.yx == t.yx);
		} else
			return false;
	}

	public GetHashCode(): number {
		return this.transform.GetHashCode();
	}
		
	//public Invert():void {
	//	this.transform = this.transform.Invert();
	//}
				
	public Reset():void {
		this.transform = CGAffineTransform.MakeIdentity();
	}
		
		
	public Rotate(angle:number, order: MatrixOrder = MatrixOrder.Prepend): void {
		angle *= (Math.PI / 180.0);  // degrees to radians 
		var affine = CGAffineTransform.MakeRotation(angle);
		if (order == MatrixOrder.Append)
			this.transform.Multiply(affine);
		else {
			affine.Multiply(this.transform);
			this.transform = affine;
		}
	}
		
	public Scale(scaleX: number, scaleY: number, order: MatrixOrder = MatrixOrder.Prepend):void {
		var affine = CGAffineTransform.MakeScale(scaleX, scaleY);
		if (order == MatrixOrder.Append)
			this.transform.Multiply(affine);
		else {
			affine.Multiply(this.transform);
			this.transform = affine;
		}
	}
		
	public TransformPoint(point: Point): Point {
		point = new Point(Math.round(this.transform.xx * point.X + this.transform.xy * point.Y + this.transform.x0),
			Math.round(this.transform.yx * point.X + this.transform.yy * point.Y + this.transform.y0));

		return point;
	}

	public TransformPoints(pts: Point[]): void {
		if (pts) {
			for (var i = 0; i < pts.length; i++){
				var point = pts[i];
				pts[i] = new Point(Math.round(this.transform.xx * point.X + this.transform.xy * point.Y + this.transform.x0),
					Math.round(this.transform.yx * point.X + this.transform.yy * point.Y + this.transform.y0));
			}
		}
	}
		
	public Translate(offsetX: number, offsetY: number, order: MatrixOrder = MatrixOrder.Prepend):void	{
		var affine = CGAffineTransform.MakeTranslation(offsetX, offsetY);
		if (order == MatrixOrder.Append)
			this.transform.Multiply(affine);
		else {
			affine.Multiply(this.transform);
			this.transform = affine;
		}
	}

}
